export const createNumberInputHandler = (
    maxLength?: number  
  ) => {
    return (e: React.FormEvent<HTMLInputElement>) => {
      const target = e.target as HTMLInputElement;
        let value = target.value;
        let result = value.replace(/[^0-9.]/g, '');
        
        // Ensure only one decimal point
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
        
        // Apply max length
        if (maxLength && result.length > maxLength) {
          result = result.slice(0, maxLength);
        }
        
        // Only update if value changed (prevents cursor jumping)
        if (target.value !== result) {
          const cursorPos = target.selectionStart || 0;
          target.value = result;
          
          // Restore cursor position
          const newCursorPos = Math.min(cursorPos, result.length);
          target.setSelectionRange(newCursorPos, newCursorPos);
        }

    };
  };